import { Heart, Star, Sparkles, Users } from "lucide-react";

export default function Badges({ creator }) {
  return (
    <div className="flex flex-wrap gap-3 mt-4 md:mt-6">

      <div className="flex items-center gap-2 px-3 py-2 rounded-xl 
      bg-gradient-to-br from-pink-500/20 to-red-500/20 backdrop-blur-md">
        <Heart className="w-4 h-4 text-pink-400" />
        <span className="text-xs text-white">People’s Choice</span>
      </div>

      <div className="flex items-center gap-2 px-3 py-2 rounded-xl 
      bg-gradient-to-br from-blue-500/20 to-indigo-500/20 backdrop-blur-md">
        <Sparkles className="w-4 h-4 text-blue-400" />
        <span className="text-xs text-white">Curator</span>
      </div>

      <div className="flex items-center gap-2 px-3 py-2 rounded-xl 
      bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur-md">
        <Star className="w-4 h-4 text-purple-400" />
        <span className="text-xs text-white">Top 1%</span>
      </div>

      <div className="flex items-center gap-2 px-3 py-2 rounded-xl 
      bg-gradient-to-br from-green-500/20 to-emerald-500/20 backdrop-blur-md">
        <Users className="w-4 h-4 text-green-400" />
        <span className="text-xs text-white">
          {creator.primaryPlatform}
        </span>
      </div>

    </div>
  );
}